import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';

const News = (props) => {
    const { content } = props;

    return (
        <div className={styles.news}>
            <p className={styles.title}>
                {
                    content && content[0] &&
                    <a href={content[0].url} target="_blank" rel="noreferrer">{content[0].title}</a>
                }
            </p>
            {
                content.slice(1).map((item, index) => {
                    return (
                        <div className={styles.subTitle} key={index}>
                            <a href={item.url} target="_blank" rel="noreferrer">{item.title}</a>
                        </div>
                    );
                })
            }
        </div>
    );
};

News.propTypes = {
    content: PropTypes.array
};

export default errorBoundary(News);
